import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, Select, Spin, DatePicker, Tooltip } from 'antd';
import { ReactSVG } from 'react-svg';
import { DATE_BACKEND_FORMAT, DAY_FORMAT, ORDER_STATUSES, TOKEN_NAME } from '../../../constants';
import dayjs from 'dayjs';
import sortBy from 'lodash/sortBy';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { doGetLocations } from '../../../modules/locations/stores/thunk';
import { doGetCompanies } from '../../../modules/companies/stores/thunk';
import { selectAllCompanies } from '../../../modules/companies/stores/slice';
import { selectAllLocations } from '../../../modules/locations/stores/slice';

const OrdersFilter = ({
  isFetching,
  query,
  form,
  onSubmit,
  //riders,
  //companies,
  // companySelectId,
  // changeSelectCompanyId,
  // optionsLocation,
  setTransactionData,
}) => {
  const nameField = 'name';
  const nameValue = query[nameField];

  const orderTypeField = 'orderType';
  const orderTypeValue = query[orderTypeField];

  const statusField = 'statuses';
  const statusValue = query[statusField];

  const deliveryDateFromField = 'deliveryDateFrom';
  const deliveryDateFromValue = query[deliveryDateFromField];

  const deliveryDateToField = 'deliveryDateTo';
  const deliveryDateToValue = query[deliveryDateToField];

  const createdAtFromField = 'createdAtFrom';
  const createdAtFromValue = query[createdAtFromField];

  const createdAtToField = 'createdAtTo';
  const createdAtToValue = query[createdAtToField];

  // const riderIdField = 'riderId';
  // const riderIdValue = query[riderIdField];

  const labelField = 'label';
  const labelValue = query[labelField];

  const companyIdField = 'companyId';
  const companyIdValue = query[companyIdField];

  const locationIdField = 'locationId';
  const locationIdValue = query[locationIdField];

  const [showDownload, setShowDownload] = useState(false);

  const dispatch = useDispatch();
  const companies = useSelector((state) => selectAllCompanies(state));
  const locations = useSelector((state) => selectAllLocations(state));
  const [companySelectId, setCompanySelectId] = useState('');
  const [optionsLocation, setOptionsLocation] = useState([]);

  // const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  useEffect(() => {
    dispatch(doGetLocations());
    dispatch(doGetCompanies());
  }, []);

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  const changeSelectCompanyId = (value) => {
    if (value) {
      setCompanySelectId(value);
      const newOptionsLocation = locations
        .filter((location) => location.companyId === value)
        .map((location) => {
          return {
            value: location.id,
            label: location.name + ' [' + location.locationType + ']',
          };
        });
      const newOptionsLocationWithAll = [{ label: 'All Locations', value: '' }, ...newOptionsLocation];
      setOptionsLocation(newOptionsLocationWithAll);
    } else {
      setCompanySelectId('');
      setOptionsLocation([{ label: 'All Locations', value: '' }]);
      form.setFieldsValue({ locationId: '' });
    }
  };

  const initialValues = () => {
    const values = {};
    values[nameField] = nameValue;
    values[orderTypeField] = orderTypeValue || '';
    values[statusField] = statusValue
      ? Array.isArray(statusValue)
        ? statusValue
        : decodeURIComponent(statusValue).split(',')
      : [];
    values['deliveryDate'] = [
      deliveryDateFromValue ? dayjs(deliveryDateFromValue, DATE_BACKEND_FORMAT) : null,
      deliveryDateToValue ? dayjs(deliveryDateToValue, DATE_BACKEND_FORMAT) : null,
    ];
    values['createdAt'] = [
      createdAtFromValue ? dayjs(createdAtFromValue, DATE_BACKEND_FORMAT) : null,
      createdAtToValue ? dayjs(createdAtToValue, DATE_BACKEND_FORMAT) : null,
    ];
    // values[riderIdField] = riderIdValue ? Number(riderIdValue) : '';
    values[labelField] = labelValue || '';
    values[locationIdField] = locationIdValue ? Number(locationIdValue) : '';
    values[companyIdField] = companyIdValue ? Number(companyIdValue) : '';
    return values;
  };

  const getParams = (values) => {
    const params = {};
    const deliveryDate = values['deliveryDate'] || [];
    const createdAt = values['createdAt'] || [];
    params[nameField] = values[nameField] || undefined;
    params[orderTypeField] = values[orderTypeField] || undefined;
    params[statusField] = values[statusField]?.length ? values[statusField].join(',') : undefined;
    params[deliveryDateFromField] = deliveryDate[0] ? deliveryDate[0].format(DATE_BACKEND_FORMAT) : undefined;
    params[deliveryDateToField] = deliveryDate[1] ? deliveryDate[1].format(DATE_BACKEND_FORMAT) : undefined;
    params[createdAtFromField] = createdAt[0] ? createdAt[0].format(DATE_BACKEND_FORMAT) : undefined;
    params[createdAtToField] = createdAt[1] ? createdAt[1].format(DATE_BACKEND_FORMAT) : undefined;
    // params[riderIdField] = values[riderIdField] || undefined;
    params[labelField] = values[labelField] || undefined;
    params[locationIdField] = values[locationIdField] || undefined;
    params[companyIdField] = values[companyIdField] || undefined;
    params['claimStatus'] = values['claim'] || undefined;
    params.mailbox = values.mailbox ?? undefined;
    return params;
  };
  const handleSubmit = (values) => {
    const params = getParams(values);
    onSubmit({ ...query, ...params, current: 1 }, true);
    setShowDownload(true);
  };

  const download = async (v) => {
    const params = { ...query, ...getParams(v) };
    // remove undefined
    Object.keys(params).forEach((k) => {
      if (params[k] === undefined) {
        delete params[k];
      }
    });

    params.take = 10000000; // for now limited at 10000000

    const queryParams = new URLSearchParams(params).toString();

    const res = await fetch(`${process.env.REACT_APP_API_URI}/1/orders/csv-download?${queryParams}`, {
      method: 'GET',

      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Cookies.get(TOKEN_NAME)}`,
      },
    });
    const d = await res.json();

    setTransactionData(d);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <div className="CommonFilter OrdersFilter">
        <Form
          form={form}
          onFinish={handleSubmit}
          initialValues={initialValues()}
          className="FilterForm OrdersFilterForm"
          layout="vertical"
        >
          <div className="FilterFormHeader">
            <h4>Filter</h4>
            <div className="actions">
              <Button size="small" type="text" onClick={handleResetButton}>
                Clear
                <ReactSVG className="icon" src="/icons/clear_all.svg" />
              </Button>
              <Button className="apply" size="small" type="link" htmlType="submit">
                Apply
                <ReactSVG className="icon" src="/icons/done.svg" />
              </Button>
              {showDownload && (
                <Tooltip title="Download all orders that match the set filters">
                  <Button className="apply" size="small" type="link" onClick={() => download(form.getFieldsValue())}>
                    Download CSV
                    <ReactSVG className="icon" src="/icons/export.svg" />
                  </Button>
                </Tooltip>
              )}
            </div>
          </div>
          <div className="FilterFormContent">
            <Row gutter={15}>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Name" name={nameField}>
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Mailbox" name={'mailbox'}>
                  <Select
                    className="select-small"
                    options={[
                      { label: 'ALL', value: '' },
                      { label: 'Regular', value: false },
                      { label: 'Mailbox', value: true },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Status" name={statusField}>
                  <Select
                    className="select-small"
                    mode="multiple"
                    allowClear
                    options={Object.keys(ORDER_STATUSES).map((key) => ({ label: ORDER_STATUSES[key], value: key }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Delivery Date" name="deliveryDate">
                  <DatePicker.RangePicker format={DAY_FORMAT} placeholder={['From', 'To']} allowEmpty={[true, true]} />
                </Form.Item>
              </Col>
              {/* {riders && riders.length > 0 && (
                <Col xs={{ span: 24 }} md={{ span: 6 }}>
                  <Form.Item label="Rider" name={riderIdField}>
                    <Select
                      className="select-small"
                      showSearch
                      filterOption={filterOption}
                      options={[
                        { label: 'ALL', value: '' },
                        ...sortBy(riders, (r) => r.user.name).map((r) => ({ label: r.user.name, value: r.id })),
                      ]}
                    />
                  </Form.Item>
                </Col>
              )} */}
              {/* <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Label" name={labelField}>
                  <Input placeholder="Label" />
                </Form.Item>
              </Col> */}
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Company" name={companyIdField}>
                  <Select
                    className="select-small"
                    options={[
                      { label: 'All Companies', value: '' },
                      ...sortBy(companies, 'name').map((company) => ({
                        value: company.id,
                        label: company.name,
                      })),
                    ]}
                    onSelect={changeSelectCompanyId}
                    style={{ minWidth: '150px' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Location" name={locationIdField}>
                  <Select
                    className="select-small"
                    disabled={!companySelectId}
                    options={optionsLocation}
                    placeholder="All locations"
                    style={{ minWidth: '150px' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Claim" name="claim">
                  <Select
                    className="select-small"
                    options={[
                      { value: '', label: '-' },
                      { value: 'FILED', label: 'Filed' },
                      { value: 'GRANTED', label: 'Granted' },
                      { value: 'REJECTED', label: 'Rejected' },
                      { value: 'ALL', label: 'All' },
                    ]}
                    placeholder="Claim status"
                    style={{ minWidth: '150px' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Created Date" name="createdAt">
                  <DatePicker.RangePicker format={DAY_FORMAT} placeholder={['From', 'To']} allowEmpty={[true, true]} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default OrdersFilter;
